<template>
<v-container fluid grid-list-lg style="min-height:100%" v-scroll="onScroll">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && allDevices.length===0">{{ $t('device.no_device_available_hint') }}</span>

  <span class="centerized title grey--text text-xs-center" v-else-if="!loading && filteredDevices.length===0">{{ $t('device.no_device_matched') }}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex xl2 lg3 md4 sm6 xs12 v-for="d in limitFilteredDevices" :key="d.key">
      <device-item :item="d" :eventlog="eventlog[d.key]||{}" :clickable="true" @click="itemClicked">
        <template v-slot:value>
          <device-battery :battery="d.battery" v-if="searchMaintainable"></device-battery>
        </template>
      </device-item>
    </v-flex>
  </v-layout>

  <v-layout justify-center v-if="!loading && limit<filteredDevices.length" class="py-4">
    <v-tooltip bottom>
      <v-btn fab color="light-grey" slot="activator" @click="moreItem">
        <v-icon>expand_more</v-icon>
      </v-btn>
      <span>{{ $t('device.show_more') }}</span>
    </v-tooltip>
  </v-layout>

  <device-action v-if="dialogControl" v-model="dialogControl" :item="actionItem" @control="controlDevice"></device-action>

  <device-chart v-if="dialogChart" v-model="dialogChart" :item="actionItem" :width="1280"></device-chart>

  <device-battery-chart v-if="dialogBatteryChart" v-model="dialogBatteryChart" :item="actionItem" :width="1280"></device-battery-chart>

  <device-editor v-if="dialogEditor" v-model="dialogEditor" :item="actionItem" :eventlog="actionItemEventlog" @toast="val=>$emit('toast',val)"></device-editor>

  <meter-prediction v-if="dialogPrediction" v-model="dialogPrediction" :item="actionItem" @toast="val=>$emit('toast',val)"></meter-prediction>

  <device-menu v-model="showMenu" :item="actionItem" :menuX="menuX" :menuY="menuY" @click="onMenuClicked"></device-menu>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import DeviceItem from './DeviceItem'
import DeviceMenu from './DeviceMenu'
import DeviceBattery from './DeviceBattery'
import DeviceActionDialog from './DeviceActionDialog'
import DeviceBatteryChartDialog from './DeviceBatteryChartDialog'
import DeviceChartDialog from './DeviceChartDialog'
import DeviceEditorDialog from './DeviceEditorDialog'
import MeterPredictionDialog from '@/components/juice/MeterPredictionDialog'

const INIT_LIMIT = 50;

export default {
  name: 'Device',
  mixins: [UserAuth],
  components: {
    'device-item': DeviceItem,
    'device-menu': DeviceMenu,
    'device-battery': DeviceBattery,
    'device-action': DeviceActionDialog,
    'device-chart': DeviceChartDialog,
    'device-battery-chart': DeviceBatteryChartDialog,
    'device-editor': DeviceEditorDialog,
    'meter-prediction': MeterPredictionDialog
  },
  data() {
    return {
      eventlog: {},
      limit: INIT_LIMIT,
      dialogControl: false,
      dialogBatteryChart: false,
      dialogChart: false,
      dialogEditor: false,
      dialogPrediction: false,
      actionItem: null,
      actionItemEventlog: {},
      showMenu: false,
      menuX: 0,
      menuY: 0
    }
  },
  watch: {
    searchKeyword(val) {
      this.limit = INIT_LIMIT;
    },
    searchGateway(val) {
      this.limit = INIT_LIMIT;
    },
    searchFuncType(val) {
      this.limit = INIT_LIMIT;
    }
  },
  computed: {
    loading() {
      return this.deviceLoading;
    },
    allDevices() {
      let list = [];
      Object.values(this.userDevice).forEach(g => {
        Object.values(g).forEach(d => {
          Object.values(d.channel || {}).forEach(c => {
            if (c.functype < 99 && c.functype > 0) {
              list.push({
                ...c,
                key: `${c.mac}-${c.uid}-${c.cid}`,
                battery: d.battery,
                hostname: (this.userMacInfo[c.mac] || {}).hostname,
                targetName: ((this.userTargetName[c.mac] || {})[c.uid] || {})[c.cid]
              });
            }
          })
        });
      });
      return list;
    },
    filteredDevices() {
      let data = this.allDevices;
      if (data) {
        if (this.searchGateway && this.searchGateway.length > 0)
          data = data.filter(item => item.mac === this.searchGateway);

        if (this.searchKeyword && this.searchKeyword.length > 0)
          data = data.filter(item => [item.name, item.targetName].join(' ').toLowerCase().indexOf(this.searchKeyword.toLowerCase()) != -1);

        if (this.searchFuncType && this.searchFuncType.length > 0)
          data = data.filter(item => this.searchFuncType.includes(item.functype));

        if (this.searchControllable === true)
          data = data.filter(item => item.ctrltype);
        else if (this.searchControllable === false)
          data = data.filter(item => !item.ctrltype);

        if (this.searchMaintainable) {
          data = data
            .map(item => {
              if (item.battery == 238) item.battery = 0;
              return item;
            })
            .filter(item => item.battery > -1 && item.battery < 35)
            .sort((a, b) => a.battery - b.battery);
        }
      }
      return data;
    },
    limitFilteredDevices() {
      return this.filteredDevices.slice(0, this.limit);
    },
    searchControllable() {
      return this.$route.meta.controllable;
    },
    searchMaintainable() {
      return this.$route.meta.maintainable;
    }
  },
  methods: {
    onScroll(e) {
      let threshold = document.body.clientHeight - window.innerHeight * 2 - window.pageYOffset;
      if (threshold < 0 && this.limit < this.filteredDevices.length)
        this.moreItem();
    },
    moreItem() {
      this.limit += INIT_LIMIT;
    },
    onMenuClicked(type) {
      switch (type) {
        case 'control':
          this.dialogControl = true;
          break;
        case 'chart':
          if (this.searchMaintainable)
            this.dialogBatteryChart = true;
          else
            this.dialogChart = true;
          break;
        case 'prediction':
          this.dialogPrediction = true;
          break;
        case 'edit':
          this.dialogEditor = true;
          break;
      }
    },
    itemClicked(item, e) {
      this.actionItemEventlog = this.eventlog[item.key] || {};
      this.actionItem = item;
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.showMenu = true;
    },
    controlDevice(item, value) {
      switch (item.ctrltype) {
        case 32:
          return this.controlThermostatFan(item, value);
        case 33:
          return this.controlThermostatMode(item, value);
        case 34:
          return this.controlThermostatTemperature(item, value);
        default:
          return this.controlSwitch(item, value);
      }
    },
    controlSwitch(item, value) {
      let [mac, uid, cid] = item.key.split('-');
      this.$db.ref('command/gateway').push().set({
        cmd: 'switch',
        mac: mac,
        uid: uid,
        cid: cid,
        val: value,
        platform: 'console'
      }).then(() => {
        this.$emit('toast', this.$t('device.command_sent'));
      }).catch(err => {
        console.log(err)
      });
    },
    controlThermostatFan(item, value) {
      let [mac, uid, cid] = item.key.split('-');
      this.$db.ref('command/gateway').push().set({
        cmd: 'thermostat',
        mac: mac,
        uid: uid,
        cid: cid,
        fan: value,
        platform: 'console'
      }).then(() => {
        this.$emit('toast', this.$t('device.command_sent'));
      }).catch(err => {
        console.log(err)
      });
    },
    controlThermostatMode(item, value) {
      let [mac, uid, cid] = item.key.split('-');
      this.$db.ref('command/gateway').push().set({
        cmd: 'thermostat',
        mac: mac,
        uid: uid,
        cid: cid,
        mode: value,
        platform: 'console'
      }).then(() => {
        this.$emit('toast', this.$t('device.command_sent'));
      }).catch(err => {
        console.log(err)
      });
    },
    controlThermostatTemperature(item, value) {
      let [mac, uid, cid] = item.key.split('-');
      this.$db.ref('command/gateway').push().set({
        cmd: 'thermostat',
        mac: mac,
        uid: uid,
        cid: cid,
        temp: value,
        unit: item.unit,
        platform: 'console'
      }).then(() => {
        this.$emit('toast', this.$t('device.command_sent'));
      }).catch(err => {
        console.log(err)
      });
    }
  },
  mounted() {
    this.$bindAsObject('eventlog', this.$db.ref('userEvent').child(this.userId));
  },
  beforeDestroy() {
    this.$db.ref('userEvent').child(this.userId).off();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/Device.vue